"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SigHelperErrors__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [],
  name: "SignatureAlreadyCancelled",
  type: "error"
}];
class SigHelperErrors__factory {
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.SigHelperErrors__factory = SigHelperErrors__factory;
_defineProperty(SigHelperErrors__factory, "abi", _abi);